import React, { Component } from "react";
import { Regular } from "@worthy-npm/clarity";
import { imageUrl, LS } from "helpers/ApplicationHelper";

class LikeDislikeBanner extends Component {
    constructor(props) {
        super(props);

        this.state = {
            gaveOpinion:
                LS.get(props.question + " " + props.eventsLabel) || false,
        };
    }

    componentDidMount() {}

    sendEvent(action) {
        const { question, eventsLabel } = this.props;
        setTimeout(() => {
            this.setState({ gaveOpinion: true });
        }, 500);
        LS.set(question + " " + eventsLabel, action);
    }

    render() {
        return (
            <div className="like-dislike-banner d-flex flex-align-center">
                <Regular
                    text={
                        this.state.gaveOpinion
                            ? this.props.closingText
                            : this.props.question
                    }
                    overrideCSS={{ fontFamily: "Roboto", lineHeight: "30px" }}
                />
                {this.state.gaveOpinion ? null : (
                    <React.Fragment>
                        <img
                            className="like-icon"
                            onTouchStart={() => {}}
                            alt="like icon"
                            src={imageUrl("experts/prosIcon.svg")}
                            onClick={() => this.sendEvent("like")}
                        />
                        <img
                            className="dislike-icon"
                            onTouchStart={() => {}}
                            alt="dislike icon"
                            src={imageUrl("experts/consIcon.svg")}
                            onClick={() => this.sendEvent("dislike")}
                        />
                    </React.Fragment>
                )}
            </div>
        );
    }
}

export default LikeDislikeBanner;
